import {define, singleton, inject} from '@injex/core';
import UserNotificationsSocket from "../../modules/user-notifications/socket/userNotificationsSocket.mdl";
import {ReportingSocket} from '../../modules/reporting/common/socket/reportingSocket.mdl';
import {HistoryReportsSocket} from '../../modules/reporting/common/socket/historyReportsSocket.mdl';

@define()
@singleton()
export default class SocketManager {

    @inject(ReportingSocket) public reporting: ReportingSocket;
    @inject(HistoryReportsSocket) public historyReports: HistoryReportsSocket;
    @inject(UserNotificationsSocket) public userNotifications: UserNotificationsSocket;
}
